import React from 'react';
import { compose } from 'recompose';

import { RouterOutlet } from '@topconagriculture/react-components';
import { RoutesConfiguration } from '@topconagriculture/frontend-utils';

import { getRoutesByUserPersonas } from '../../core/helpers/utils/utils';
import withUserPersonas from '../../hocs/withUserPersonas';
import { UserPersonas } from '../../store/user/user.types';

export interface SectionRouterProps {
  routeConfig: RoutesConfiguration;
}

export interface SectionRouterPrivateProps extends SectionRouterProps {
  userPersonas: UserPersonas;
}

const SectionRouter: React.FunctionComponent<SectionRouterPrivateProps> = ({ routeConfig, userPersonas }) => (
  <RouterOutlet routes={getRoutesByUserPersonas(routeConfig, userPersonas)} />
);

export default compose<SectionRouterPrivateProps, SectionRouterProps>(withUserPersonas)(SectionRouter);
